import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import { Box, Button, Flex } from '@chakra-ui/react';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Color } from 'src/theme/color';
import ReactPlayer from 'react-player';
import { ChevronRightIcon } from '../../../../../utils/icons/chevronRight';
import { ChevronLeftIcon } from '../../../../../utils/icons/chevronLeft';

interface IMockupScreenshots {
	screens: string[];
	video: string;
	color?: string;
}

const YoutubeSlide = ({ url, isSelected = true }: { url: string; isSelected?: boolean }) => (
	<ReactPlayer
		height="300px"
		width="100%"
		url={url}
		playing={isSelected}
		controls
		muted
		loop
	/>
);

export const MockupScreenshots = ({ screens, video, color }: IMockupScreenshots) => {
	const customRenderItem = (item: any) => <item.type {...item.props} />;

	const arrow = ({
		isLeft,
		hasNext,
		clickHandler,
	}: {
		isLeft: boolean;
		hasNext: boolean;
		clickHandler: () => void;
	}) => {
		return screens.length > 1 || video.length === 1 ? (
			<Flex
				cursor="pointer"
				zIndex="10"
				position="absolute"
				top="calc(50% - 48px)"
				w="27px"
				h="72px"
				right="-12px"
				left={isLeft ? '-16px' : 'auto'}
				display="flex"
				backgroundColor={color}
				justify="center"
				align="center"
				onClick={clickHandler}
				borderRadius="99px"
			>
				<Button
					disabled={!hasNext}
					bgColor="transparent"
					border="none"
				>
					{isLeft ? <ChevronLeftIcon /> : <ChevronRightIcon />}
				</Button>
			</Flex>
		) : null;
	};
	return (
		<Box
			css={{
				'.carousel-root': {
					width: '100%',
				},
				'.carousel-slider': {
					overflow: 'initial',
				},
				'.slider-wrapper': {
					width: '100%',
				},
				'.carousel .thumbs-wrapper': {
					margin: '0px',
					marginTop: '20px',
				},
				'.carousel .slide iframe': {
					margin: '0px',
					width: '100%',
				},
				'.thumbs.animated': {
					maxWidth: '2000px',
				},
			}}
		>
			<Carousel
				showStatus={false}
				showIndicators={false}
				renderItem={customRenderItem}
				renderArrowPrev={(clickHandler: any, hasNext: any, label: any) =>
					arrow({
						isLeft: true,
						hasNext,
						clickHandler,
					})
				}
				dynamicHeight={false}
				renderArrowNext={(clickHandler: any, hasNext: any, label: any) => arrow({ isLeft: false, hasNext, clickHandler })}
			>
				{video && (
					<YoutubeSlide
						key={video}
						url={video}
					/>
				)}
				{
					screens.map(screen => (
						<Box
							h="300px"
							key={`${screen}`}
						>
							<img
								src={screen}
								alt=""
							/>
						</Box>
					)) as any
				}
			</Carousel>
		</Box>
	);
};
